import { AbacoWebModule } from '@abaco/web-common/src/app';
import globals from "./globals";
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import DashboardModule from '@abaco/dashboard-module/src/modules/dashboard';
import DashboardChartsModule from '@abaco/dashboard-module/src/modules/charts';
import ChartApi from './api/ChartApi';
import CropPlanModule from '@abaco/crop-plan-module/src/modules/crop-plan-module';

export const MODULE_ID = "ferrero_charts_module";

export default class FerreroChartsModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private apiCreated = false;
    private chrtApi!: ChartApi;

    readonly id = MODULE_ID;
    readonly globalComponents = globals;

    dependsOn = {
        [CropPlanModule.MODULE_ID]: () => new CropPlanModule,
        [DashboardModule.MODULE_ID]: () => new DashboardModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
    };

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const ChartApi = (await import("./api/ChartApi")).default;
        this.chrtApi = new ChartApi(http);
    }

    get chartApi() {
        return this.chrtApi;
    }
}
